module.exports = __webpack_public_path__ + "img/student4.1eb55b1f.png";